module.exports = __WEBPACK_EXTERNAL_MODULE_11__;


//////////////////
// WEBPACK FOOTER
// external {"amd":"openfl/errors/Error","root":["openfl","errors","Error"],"commonjs":"openfl/errors/Error","commonjs2":"openfl/errors/Error"}
// module id = 11
// module chunks = 0